<template>
  <DashboardHost ref="dashboard" />
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { locationStore } from '@/stores/location'
import DashboardHost from '@/components/dashboard/DashboardHost.vue'
export default {
  name: 'DashboardView',
  components: {
    DashboardHost
  },
  mounted() {
    let data = {
      firm: 1,
      category: 'App'
    }
    this.resetPreferences()
    this.getPreferences(data)
    // this.$refs.dashboard.init()
  },
  methods: {
    ...mapActions(locationStore, ['resetPreferences', 'getPreferences'])
  }
}
</script>
<style lang="scss" scoped></style>
